/**
 * Fecha efectiva de la transferencia para mostrar en tablas y detalle:
 * - COMPLETED → completedAt (o firstAssignedAt en datos antiguos sin columna)
 * - CANCELLED → cancelledAt
 * - PENDING → createdAt (inicio del trámite)
 */
export type TransferLike =
  | {
      status?: string;
      createdAt?: string;
      completedAt?: string | null;
      cancelledAt?: string | null;
    }
  | null
  | undefined;

export function getTransferDisplayAtIso(
  transfer: TransferLike,
  productFirstAssignedAt?: string | null,
): string | undefined {
  if (!transfer) return undefined;
  const s = (transfer.status || '').toUpperCase();
  if (s === 'COMPLETED') {
    if (transfer.completedAt) return transfer.completedAt;
    if (productFirstAssignedAt) return productFirstAssignedAt;
    return transfer.createdAt;
  }
  if (s === 'CANCELLED') {
    if (transfer.cancelledAt) return transfer.cancelledAt;
    return transfer.createdAt;
  }
  return transfer.createdAt;
}

const esDateTime: Intl.DateTimeFormatOptions = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
};

export function formatTransferEventDateEs(transfer: TransferLike): string {
  const iso = getTransferDisplayAtIso(transfer);
  if (!iso) return 'N/A';
  return new Date(iso).toLocaleString('es-ES', esDateTime);
}
